import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import hareNiemeyer from 'hare-niemeyer/dist/index.js';

export const calulateBarWidth = (percentValue, totalValue) => {
  const val = (percentValue / totalValue) * 100;
  return isFinite(val) ? val : 0;
};

export const getSortedBarValues = (insightsData, limit) => {
  const values = insightsData.map((lo) => {
    const numQuestions = get(lo, 'numQuestions', 0);

    // If there are no questions, force unanswered to be 100%
    const unanswered = numQuestions === 0 ? 1 : get(lo, 'unanswered', 0);
    const unansweredNumQuestions = numQuestions === 0 ? 1 : numQuestions;

    const roundedTotals = hareNiemeyer(
      {
        correctOnFirstTry: calulateBarWidth(
          get(lo, 'correctOnFirstTry', 0),
          numQuestions
        ),
        eventuallyCorrect: calulateBarWidth(
          get(lo, 'eventuallyCorrect', 0),
          numQuestions
        ),
        incorrect: calulateBarWidth(get(lo, 'incorrect', 0), numQuestions),
        unanswered: calulateBarWidth(unanswered, unansweredNumQuestions),
      },
      100
    );

    return {
      ...lo,
      ...roundedTotals,
    };
  });
  const sortedData = orderBy(
    values,
    ['incorrect', 'eventuallyCorrect', 'correctOnFirstTry', 'unanswered'],
    ['desc', 'desc', 'asc', 'desc']
  );
  if (limit) return sortedData.slice(0, limit);
  return sortedData;
};
